export default "__VITE_ASSET__BnIKoVrI__"